import request from '@/utils/request'

// 作業可能日調整詳細-情報(協力会社)
export function workableDateRequestInfo(possibleDateDetailId) {
  return request({
    url: `/api/workableDateRequest/partner/${possibleDateDetailId}`,
    method: 'get',
  })
}
// 作業可能日調整詳細-日程情報(協力会社)
export function getWorkableDateTimeList(data) {
  return request({
    url: `/api/workableDateRequest/partner/calendar`,
    method: 'post',
    data,
  })
}
// 作業可能日調整詳細-日程回答(協力会社)
export function submitAnswerSchedule(data) {
  return request({
    url: `/api/workableDateRequest/partner/answer/schedule`,
    method: 'post',
    data,
  })
}

// top(協力会社)
export function getTopWorkableDateTimeList(data) {
  return request({
    url: `/api/works/top/partner/calendar`,
    method: 'post',
    data,
  })
}
